// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkMark_selected__pgUfO path {\n  color: green; }\n\n.linkMark_notSelected__1AdmO path {\n  color: #4646; }\n\n.linkMark_container__1jF7u {\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n", ""]);
// Exports
exports.locals = {
	"selected": "linkMark_selected__pgUfO",
	"notSelected": "linkMark_notSelected__1AdmO",
	"container": "linkMark_container__1jF7u"
};
module.exports = exports;
